module.exports = __webpack_public_path__ + "img/img56.879f49d9.svg";